import { Injectable } from '@angular/core';
import { Plant } from '../interfaces/plant.interface';

@Injectable({
  providedIn: 'root'
})
export class FixedDataService {

  private _plants: Plant[] = [
    {code: '0051', name: 'Fort Mill'}
  ];

  get plants(){
    return [...this._plants];
  }

  constructor() { }
}
